document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.btn-add-to-cart');
  
  addToCartButtons.forEach(button => {
    // Only add event listener if it's an "Add to Cart" button, not "Buy Now"
    if (button.name === 'add') {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const form = this.closest('form');
        const formData = new FormData(form);
        
        // Add item to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          console.log('Item added to cart:', data);
          
          // Fetch updated cart to get current item count
          return fetch('/cart.js');
        })
        .then(response => response.json())
        .then(cart => {
          console.log('Updated cart:', cart);
          
          // Update or create cart count bubble
          const cartIcon = document.querySelector('#cart-icon-bubble');
          
          if (cartIcon && cart.item_count > 0) {
            let bubble = cartIcon.querySelector('.cart-count-bubble');
            
            // If bubble doesn't exist, create it
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              
              // Add the count span (only if < 100 as per your theme logic)
              if (cart.item_count < 100) {
                const countSpan = document.createElement('span');
                countSpan.setAttribute('aria-hidden', 'true');
                countSpan.textContent = cart.item_count;
                bubble.appendChild(countSpan);
              }
              
              // Add visually-hidden span for accessibility
              const hiddenSpan = document.createElement('span');
              hiddenSpan.className = 'visually-hidden';
              hiddenSpan.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;
              bubble.appendChild(hiddenSpan);
              
              // Append bubble to cart icon
              cartIcon.appendChild(bubble);
            } else {
              // Bubble exists, just update the count
              const countSpan = bubble.querySelector('span[aria-hidden="true"]');
              const hiddenSpan = bubble.querySelector('.visually-hidden');
              
              if (cart.item_count < 100) {
                if (countSpan) {
                  countSpan.textContent = cart.item_count;
                }
              }
              if (hiddenSpan) {
                hiddenSpan.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;
              }
            }
          }
          
          // Wait for drawer to refresh, THEN open it
          refreshCartDrawer(cart).then(() => {
            setTimeout(() => {
              openCartDrawer();
            }, 100);
          });
          
          // Dispatch multiple custom events that themes might listen to
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cart }
          }));
          
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cart }
          }));
          
          window.dispatchEvent(new CustomEvent('cartChanged', {
            bubbles: true,
            detail: { cart: cart }
          }));
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          // Fallback to default form submission
          form.submit();
        });
      });
    }
  });
  
  // Function to open cart drawer
  function openCartDrawer() {
    // Method 1: Dawn theme and similar modern themes
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement && typeof cartDrawerElement.open === 'function') {
      cartDrawerElement.open();
      return;
    }
    
    // Method 2: Trigger cart icon/button click - but prevent navigation
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      // Temporarily remove href to prevent navigation
      const originalHref = cartIcon.getAttribute('href');
      cartIcon.removeAttribute('href');
      
      // Click it to trigger any drawer open handlers
      cartIcon.click();
      
      // Restore href after a moment
      setTimeout(() => {
        if (originalHref) {
          cartIcon.setAttribute('href', originalHref);
        }
      }, 100);
      return;
    }
    
    // Method 3: Direct drawer manipulation
    const drawerSelectors = [
      '#CartDrawer',
      '.cart-drawer',
      '[data-cart-drawer-target]',
      '.drawer--cart',
      '#cart-drawer'
    ];
    
    for (const selector of drawerSelectors) {
      const drawer = document.querySelector(selector);
      if (drawer) {
        drawer.classList.add('active', 'is-open', 'open', 'drawer--is-open');
        drawer.setAttribute('aria-hidden', 'false');
        
        // Add overlay if it exists
        const overlay = document.querySelector('.drawer__overlay, .overlay, [data-drawer-overlay]');
        if (overlay) {
          overlay.classList.add('active', 'is-open', 'open');
        }
        return;
      }
    }
    
    // Method 4: Try to find and trigger a cart open function
    if (window.theme && typeof window.theme.openCart === 'function') {
      window.theme.openCart();
    } else if (window.Shopify && typeof window.Shopify.cartOpen === 'function') {
      window.Shopify.cartOpen();
    }
  }
  
  // Function to refresh cart drawer contents
  function refreshCartDrawer(cart) {
    return new Promise((resolve) => {
      // Method 1: Try to use theme's built-in cart refresh
      if (window.theme && typeof window.theme.refreshCart === 'function') {
        window.theme.refreshCart();
        
        // Remove is-empty class
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cart.item_count > 0) {
          cartDrawer.classList.remove('is-empty');
        }
        
        resolve();
        return;
      }
      
      // Method 2: Fetch and update cart drawer HTML
      fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
          // Try to find cart drawer content containers
          const drawerContentSelectors = [
            'cart-drawer-items',
            '.cart-drawer__items',
            '#CartDrawer-CartItems',
            '.drawer__inner',
            '[data-cart-items]'
          ];
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          drawerContentSelectors.forEach(selector => {
            const existingContent = document.querySelector(selector);
            const newContent = doc.querySelector(selector);
            
            if (existingContent && newContent) {
              existingContent.innerHTML = newContent.innerHTML;
            }
          });
          
          // Update cart totals
          const totalSelectors = [
            '.cart-drawer__footer',
            '.totals',
            '[data-cart-total]',
            '.cart__footer'
          ];
          
          totalSelectors.forEach(selector => {
            const existingTotal = document.querySelector(selector);
            const newTotal = doc.querySelector(selector);
            
            if (existingTotal && newTotal) {
              existingTotal.innerHTML = newTotal.innerHTML;
            }
          });
          
          // IMPORTANT: Remove is-empty class from cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cart.item_count > 0) {
            cartDrawer.classList.remove('is-empty');
          }
          
          // Also check for other possible empty class variations
          const drawerElements = document.querySelectorAll('.cart-drawer, #CartDrawer, [data-cart-drawer]');
          drawerElements.forEach(drawer => {
            if (cart.item_count > 0) {
              drawer.classList.remove('is-empty', 'empty', 'cart-empty');
            }
          });
          
          resolve(); // Resolve after content is updated
        })
        .catch(err => {
          console.error('Error refreshing cart drawer:', err);
          
          // Fallback: Reload the entire cart drawer section
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            fetch('/cart.js')
              .then(res => res.json())
              .then(cartData => {
                cartDrawer.renderContents(cartData);
                
                // Remove is-empty class after render
                if (cartData.item_count > 0) {
                  cartDrawer.classList.remove('is-empty');
                }
                
                resolve(); // Resolve after render
              })
              .catch(() => resolve()); // Resolve even on error
          } else {
            resolve(); // Resolve if no fallback available
          }
        });
    });
  }
});